import { useState } from "react";
import { useFeatureTheme } from "../../context/FeatureThemeContext";
import { Modal } from "../common/Modal";
import { Button } from "../common/Button";

const SEEN_KEY = "beekeeper.changelog_seen_version";

/** Bump CURRENT_VERSION on release and add an entry -- shown once per
 * version per browser. Entries can be tagged basic/advanced/all so users
 * only see changes relevant to their theme. */
const CURRENT_VERSION = "1.0.0";
const CHANGELOG = [
  { version: "1.0.0", audience: "all", text: "Welcome to the new Bee Keeper dashboard! Theme-aware Basic/Advanced/Custom experience, glove-friendly controls, and dark mode." },
  { version: "1.0.0", audience: "advanced", text: "Advanced theme: health scoring, queen lineage, treatments/feedings, team collaboration, and P&L reporting are now available." },
];

export function WhatsNewModal() {
  const { theme, loading } = useFeatureTheme();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(SEEN_KEY) === CURRENT_VERSION);

  if (loading || dismissed) return null;

  const relevant = CHANGELOG.filter((c) => c.version === CURRENT_VERSION && (c.audience === "all" || (c.audience === "advanced" && theme !== "Basic")));
  if (relevant.length === 0) return null;

  function dismiss() {
    localStorage.setItem(SEEN_KEY, CURRENT_VERSION);
    setDismissed(true);
  }

  return (
    <Modal open onClose={dismiss} title={`What's New (v${CURRENT_VERSION})`} footer={<Button onClick={dismiss}>Got it</Button>}>
      <ul>
        {relevant.map((c, i) => <li key={i} style={{ marginBottom: "var(--space-2)" }}>{c.text}</li>)}
      </ul>
    </Modal>
  );
}
